import GPFSEvent from './events/FSEvent.json';
import GPProcessEvent from './events/ProcessEvent.json';
import GPClickEvent from './events/ClickEvent.json';
import GPUSBEvent from './events/USBEvent.json';
import GPDownloadEvent from './events/DownloadEvent.json';
import GPScreenshotEvent from './events/ScreenshotEvent.json';
import appextension from './types/appextension.json';

import bundle from './types/bundle.json';
import device from './types/device.json';
import file from './types/file.json';
import group from './types/group.json';
import infoDictionary from './types/infoDictionary.json';
import process from './types/process.json';
import signing from './types/signing.json';
import string from './types/string.json';
import user from './types/user.json';
import binary from './types/binary.json';

import action from './configs/action.json';
import analytic from './configs/analytic.json';
import profile from './configs/profile.json';

import one from './insights/1.json';
import two from './insights/2.json';
import three from './insights/3.json';
import four from './insights/4.json';
import five from './insights/5.json';
import six from './insights/6.json';
import seven from './insights/7.json';

import endpoint from './endpoint.json';

import infoSync from './schemas/InfoSync.json';
import profileSchema from './schemas/Profile.json';
import AlertConfigSchema from './schemas/AlertConfig.json';
import LogConfigSchema from './schemas/LogConfig.json';
import CacheConfigSchema from './schemas/CacheConfig.json';
import DataConfigSchema from './schemas/DataConfig.json';
import HTTPEndpointSchema from './schemas/HTTPEndpoint.json';

export default {
  /* eslint-disable no-param-reassign */
  getTypeDefinitions() {
    const defs = {
      events: {
        GPFSEvent,
        GPProcessEvent,
        GPClickEvent,
        GPScreenshotEvent,
        GPUSBEvent,
        GPDownloadEvent,
      },
      types: {
        appextension,
        bundle,
        device,
        file,
        group,
        infoDictionary,
        process,
        signing,
        string,
        user,
        binary,
      },
      configs: {
        action,
        analytic,
        profile,
      },
      // This mapping is needed to map definitions to the configs found in action
      // e.g. action.remoteAlertConfig.data
      mappings: {
        fsEvent: GPFSEvent,
        procEvent: GPProcessEvent,
        screenshotEvent: GPScreenshotEvent,
        clickEvent: GPClickEvent,
        downloadEvent: GPDownloadEvent,
        usbEvent: GPUSBEvent,
        file,
        process,
        user,
        group,
        binary,
      },
      insights: [
        one,
        two,
        three,
        four,
        five,
        six,
        seven,
      ],
      endpoint,
      schemas: {
        infoSync,
        profile: profileSchema,
        alertConfig: AlertConfigSchema,
        logConfig: LogConfigSchema,
        cacheConfig: CacheConfigSchema,
        dataConfig: DataConfigSchema,
        httpEndpoint: HTTPEndpointSchema,
      },
    };
    return defs;
  },
};
